import { FieldModel } from "../shared/model/field-model";

export function createFieldHandlers(
  fieldState: FieldModel,
  setState: (state: FieldModel) => void,
  validator: (value: string) => string[]
): [
  (event: React.ChangeEvent<HTMLInputElement>) => void,
  (event: React.FocusEvent<HTMLInputElement>) => void,
  () => void
] {
  const runValidator = () => {
    fieldState.messages = validator(fieldState.value);
  };

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    fieldState.value = event.currentTarget.value;
    if (fieldState.isTouched) {
      runValidator();
    }
    setState({ ...fieldState });
  };

  const onBlurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
    fieldState.value = event.currentTarget.value;
    fieldState.isTouched = true;
    runValidator();
    setState({ ...fieldState });
  };

  const invokeValidation = () => {
    fieldState.isTouched = true;
    runValidator();
    setState({ ...fieldState });
  };
  // return functions so the can be used in components..
  return [onChangeHandler, onBlurHandler, invokeValidation];
}

export function createDOBFieldHandlers(
  fieldState: FieldModel,
  setState: (state: FieldModel) => void,
  validator: (value: string) => string[]
): [(value: string) => void, (value: string) => void, () => void] {
  const runValidator = () => {
    fieldState.messages = validator(fieldState.value);
  };

  const onChangeHandler = (value: string) => {
    fieldState.value = value;
    if (fieldState.isTouched) {
      runValidator();
    }
    setState({ ...fieldState });
  };

  const onBlurHandler = (value: string) => {
    fieldState.value = value;
    fieldState.isTouched = true;
    runValidator();
    setState({ ...fieldState });
  };

  const invokeValidation = () => {
    fieldState.isTouched = true;
    runValidator();
    setState({ ...fieldState });
  };
  // return functions so the can be used in components..
  return [onChangeHandler, onBlurHandler, invokeValidation];
}
